import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import { Box, Typography } from "@mui/material";
import { getUploadFileFullPathDownload } from "app/utils/appHelpers";
import { useTemplateFontSettings } from "styles/templateFontSettings";

function PreviewMeetingMailFilesCard({ meeting, mailFiles }) {
    

    if (mailFiles.length === 0) return null;

    return (
        <>
            <Box sx={{ marginY: 1 }} />
            <JumboCardQuick
                title={
                    <Typography sx={{ lineHeight: 1 }}>
                        E-posta ile ilgililere gönderilen dosya
                    </Typography>
                }
                headerSx={{ borderBottom: 1, borderBottomColor: "divider" }}
                wrapperSx={{ p: 0 }}
            >
                <Box sx={{ p: 2 }}>
                    {mailFiles.map(item => (
                        <Box key={item.id} sx={{ mb: 1 }}>
                            <Typography
                                sx={{
                                    lineHeight: 1,
                                    cursor: 'pointer',
                                    color: 'primary.main',
                                    textDecoration: 'underline'
                                }}
                                onClick={() => getUploadFileFullPathDownload(
                                    `meetingFiles/${meeting.inst}-${meeting.id}`,
                                    item.id + item.ext,
                                    item.fileType
                                )}
                            >
                                {item.fileType}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </JumboCardQuick>
        </>
    );
}

export default PreviewMeetingMailFilesCard;
